import { cn } from '../../utils/cn'

interface Props {
  type: 'button' | 'submit'
  text: string
  children?: React.ReactNode
  width?: string
  bgColor?: 'bg-primaryBlue' | 'bg-[#E1ECFC]'
  textColor?: 'text-white' | 'text-black'
  onClickHandler?: () => void
  disabled?: boolean
  className?: string
  /** Native tooltip, useful for explaining why a button is disabled. */
  title?: string
}

const Button = ({
  type,
  text,
  children,
  bgColor = 'bg-primaryBlue',
  textColor = 'text-white',
  width = 'w-full',
  onClickHandler,
  disabled = false,
  className,
  title,
}: Props) => {
  return (
    <button
      type={type}
      className={cn(
        `${width} ${bgColor} ${textColor}  rounded-5px text-base font-medium py-[13px] px-7 cursor-pointer flex gap-2 justify-center items-center max-w-max hover:opacity-90 transition-opacity print:hidden disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:opacity-40`,
        className,
      )}
      disabled={disabled}
      title={title}
      onClick={onClickHandler}
    >
      {children}
      <span>{text}</span>
    </button>
  )
}

export default Button
